<template>
  <el-form
    v-loading="loading"
    label-width="150px"
    label-position="right"
    label-suffix=""
  >
    <page-block title="仓库基础信息" name="仓库详情">
      <el-row>
        <el-col :span="10">
          <el-form-item label="仓库编码：">
            <span>{{ form.warehouseCode }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="仓库名称：">
            <span>{{ form.warehouseName }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="是否自营：">
            <span>{{ form.ascriptionType | filterAscriptionType }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="运营主体：">
            <span>{{ form.tenantName }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="支持温层：">
            <span>{{ form.temperatureLayer | filterTemperature }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="制冷区间：">
            <span>{{ filterSection }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="仓库面积(㎡)：">
            <span>{{ form.area }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="可出租面积(㎡)：">
            <span>{{ form.availableArea }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="联系人：">
            <span>{{ form.linkMan }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="联系人电话：">
            <span>{{ form.telephone }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="地址：">
            <span>{{ form.provinceName ? form.address ? `${form.provinceName}${form.cityName}${form.countyName}${form.address}` :`${form.provinceName}${form.cityName}${form.countyName}` : '' }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="经纬度：">
            <span>{{ `经度：${form.longitude} 纬度：${form.latitude}` }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="投产时间：">
            <span>{{ filterTime(form.buildTime) }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="客服电话：">
            <span>{{ form.hotline }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="20">
          <el-form-item label="仓库类型：">
            <el-button
              v-for="(item,index) in form.type"
              :key="index"
              type="primary"
            >
              {{ item | filterWarehouseType(warehouseType) }}
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="20">
          <el-form-item label="消防等级：">
            <el-button
              v-for="(item,index) in form.fireRating"
              :key="index"
              type="primary"
            >
              {{ item | filterQualification(ratingOption) }}
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-col :span="20">
        <el-form-item label="证照信息：">
          <div slot="label">
            <i class="el-icon-postcard form-postcard" />证照信息：
          </div>
          <span v-for="(item, index) in form.qualification" :key="index">
            <i class="el-icon-success form-postcard" />
            {{ item | filterQualification(qualificationOption) }}
          </span>
        </el-form-item>
      </el-col>
      <el-row>
        <el-col :span="20">
          <el-form-item label="特色标签：">
            <el-tag
              v-for="(item,index) in form.label"
              :key="index"
              :type="headleSetType(index)"
            >
              {{ item }}
            </el-tag>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="20">
          <el-form-item label="配套设施：">
            <el-tag v-for="(item,index) in form.facilities" :key="index">
              {{ item }}
            </el-tag>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="20">
          <el-form-item label="库内设备：">
            <el-tag v-for="(item,index) in form.equipments" :key="index">
              {{ item }}
            </el-tag>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="20">
          <el-form-item label="仓库简介：">
            <span class="introduction">
              {{ form.introduction }}
            </span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="20">
          <el-form-item label="服务范围：">
            <el-col :span="5">
              <span>提货服务</span>
              <el-switch :value="form.isSupportPickup" />
            </el-col>
            <el-col :span="5">
              <span>好仓推荐</span>
              <el-switch :value="form.isRecommend" />
            </el-col>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="20">
          <el-form-item label="照片或视频：">
            <div class="files">
              <div
                v-for="(item,index) in form.files"
                :key="index"
                v-dragging="{ item: item, list: form.files, group: 'files' }"
                class="midea-box"
              >
                <img
                  v-if="item.fileType.indexOf(FILE_TYPE.IMAGE) >= 0"
                  :src="item.filePath"
                  alt=""
                >
                <video v-if="item.fileType.indexOf(FILE_TYPE.VIDEO) >= 0" :src="item.filePath" />
                <div v-if="item.fileType.indexOf(FILE_TYPE.IMAGE) >= 0" class="midea-icon">
                  <i class="el-icon-zoom-in" @click="handlePictureCardPreview(item.filePath)" />
                </div>
                <div v-if="item.fileType.indexOf(FILE_TYPE.VIDEO) >= 0" class="midea-icon">
                  <i class="el-icon-video-play" @click="handlePlay(item.filePath)" />
                </div>
              </div>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </page-block>

    <page-block title="计费信息">
      <el-col :span="23" class="warehouse-offer">
        <el-switch :value="form.isShowChargeInfo" />
        <div>*开启代表在云仓界面展示价格。</div>
      </el-col>
      <template v-for="(item, index) in form.chargeInfos">
        <el-row :key="`chargeInfos${index}`">
          <el-col :span="5">
            <el-form-item label="温层：">
              <span>{{ item.temperatureLayerName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="面积(㎡)：">
              <span>{{ item.area }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="制冷区间：">
              <span v-if="item.temperatureLayerCode !== DICTIONARY.NORMAL">{{ `${item.minTemperature} -- ${item.maxTemperature}` }}</span>
              <span v-else>环境温度</span>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="计费单价：">
              <span>{{ item.price }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="计费单位：">
              <span>{{ item.unit }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <el-dialog :visible.sync="dialogVisible">
        <img
          width="100%"
          :src="dialogImageUrl"
          alt=""
        >
      </el-dialog>
    </page-block>
    <page-block title="仓库运营信息">
      <p class="title">
        每日收货时间范围
      </p>
      <template v-for="(item, index) in form.storeTime">
        <el-row :key="`storeTime${index}`">
          <el-col :span="10">
            <el-form-item label="温层：">
              <span>{{ item.temperatureLayerCode | filterTemperatureLayer(temperType) }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="时间范围：">
              <span>{{ `${item.startTime} - ${item.endTime}` }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <p class="title">
        每日发货时间范围
      </p>
      <template v-for="(item, index) in form.deliverTime">
        <el-row :key="`deliverTime${index}`">
          <el-col :span="10">
            <el-form-item label="温层：">
              <span>{{ item.temperatureLayerCode | filterTemperatureLayer(temperType) }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="时间范围：">
              <span>{{ `${item.startTime} - ${item.endTime}` }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <el-dialog :visible.sync="dialogVisible">
        <img
          width="100%"
          :src="dialogImageUrl"
          alt=""
        >
      </el-dialog>
    </page-block>
  </el-form>
</template>

<script>
import { create } from '@/api/warehouse';

import PageBlock from '@/components/PageBlock/index.vue';

import dayjs from 'dayjs';
import {
  RECEIVING, ASCRIPTION_TYPE, FILE_TYPE, TagType,
  DICTIONARY,
} from '../constant';
import Mixin from './mixin';

export default {
  components: {
    PageBlock,
  },
  filters: {
    filterTemperature(val) {
      return val && val.map((item) => item.temperatureLayerName).join('、');
    },
    filterTemperatureLayer(val, temperType) {
      const result = temperType.find((item) => item.code === val);
      return result && result.name;
    },
    filterWarehouseType(val, warehouseType) {
      const result = warehouseType.find((item) => item.code === val);
      return result && result.name;
    },
    filterQualification(val, qualificationOption) {
      const result = qualificationOption.find((item) => item.code === val);
      return result && result.name;
    },
    filterStore(val, storeType) {
      const result = storeType.find((item) => item.code === val);
      return result && result.name;
    },
    filterAscriptionType(val) {
      if (val) {
        return ASCRIPTION_TYPE[val];
      }
      return '';
    },
  },
  mixins: [Mixin],
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      RECEIVING,
      FILE_TYPE,
      TagType,
      DICTIONARY,
      dialogImageUrl: '',
      dialogVisible: false,
    };
  },
  computed: {
    filterSection() {
      return `${this.form.temperatureMin} - ${this.form.temperatureMax}`;
    },

    filterUnitPrice() {
      return `${this.form.minPrice} - ${this.form.maxPrice}`;
    },
  },
  created() {},
  mounted() {
    this.$dragging.$on('dragged', () => {
      this.getvalidate();
    });
  },
  methods: {
    // 上传图片预览
    handlePictureCardPreview(filePath) {
      this.dialogImageUrl = filePath;
      this.dialogVisible = true;
    },
    // 设置标签颜色
    headleSetType(index) {
      return TagType[index % TagType.length];
    },
    // 视频播放预览
    handlePlay(filePath) {
      window.open(filePath);
    },
    filterTime(val) {
      if (!val) return '';
      return dayjs(val).format('YYYY');
    },
    // 保存图片顺序
    async getvalidate() {
      const { form } = this;
      await create(form);
    },
  },
};
</script>

<style  lang="scss" scoped>
.cover-image {
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #999999;
}
.title{
  line-height: 40px;
  padding-left: 30px;
  font-weight: 500;
}
.files {
  display: flex;
  flex-wrap: wrap;
  .midea-box{
    z-index: 1;
    transition: all .3s ease-out;
    width: 150px;
    height:150px;
    margin:0 20px 8px;
    border: 1px solid #ccc;
    img{
      width: 100%;height: 100%;
    }
    video{
      width: 100%;height: 100%;
    }
    .midea-icon{
      width: 100%;
      height: 100%;
      position: absolute;
      left:0;
      top: 0;
      z-index:100;
      display:none;
      i{
        font-size: 30px;
        color:white;
        position: absolute;
        left:50%;
        top:50%;
        transform:translate(-50%,-50%);
      }
    }
  }
}

.midea-box:hover {
  z-index: 2;
  transform: scale(1.5);
  .midea-icon{
    display:block;
  }
}
.midea-box:active {
  z-index: 1;
  transform: scale(1);
}
.introduction{
  display:inline-block;
  width: 800px;
}
.warehouse-offer{
  text-align: right;
  margin-top: -40px;
  margin-bottom: 10px;
}

.form-postcard {
  color: #f56c6c;
  font-size: 20px;
  margin-right: 4px;
}

.el-icon-success {
  font-size: 16px;
  color: #059E84;
}
</style>
